import { useAuthentication } from '@cp-shared-9/frontend-ui';
import { landingPagePath } from '../components/navigation/paths';

export function useLogout(pathFn: () => string = landingPagePath): () => Promise<void> {
    const { logout } = useAuthentication();

    return (): Promise<void> => logout({ redirectUri: window.location.origin + pathFn() });
}
